import React from 'react';
import Card from '../components/Card';
import { gql } from '../graphql/generated/gql';
import type { DocumentType } from '../graphql/generated/gql';
import TopicCardContent from './TopicCardContent';
import useAllTopics from './useAllTopics';

const TOPIC_FRAGMENT = gql(`
  fragment TopicResultCard_topic on Topic {
    ...TopicCardContent_topic
  }
`);

const ANCESTORS_FRAGMENT = gql(`
  fragment TopicResultCard_ancestors on AncestorSearchResult {
    ...TopicCardContent_ancestors
  }
`);

interface TopicResultCardProps
  extends Omit<
    React.ComponentProps<typeof TopicCardContent>,
    'childTopics' | 'topic'
  > {
  topic: DocumentType<typeof TOPIC_FRAGMENT>;
  ancestors?: DocumentType<typeof ANCESTORS_FRAGMENT>[];
}

const TopicResultCard = (props: TopicResultCardProps) => {
  const topics = useAllTopics({ flatten: true });
  const { childTopics } = topics.find(({ id }) => id === props.topic.id) || {};

  return (
    <Card noPadding>
      <TopicCardContent childTopics={childTopics} {...props} />
    </Card>
  );
};

export default TopicResultCard;
